export var quiz = [
  {
    type: "multiple",
    difficulty: "easy",
    category: "JavaScript Events",
    question: "Which event occurs when a user clicks on an element?",
    correct_answer: "click",
    incorrect_answers: ["mouseover", "keydown", "submit"],
  },
  {
    type: "multiple",
    difficulty: "medium",
    category: "JavaScript Events",
    question: "Which event triggers when a user presses a key down?",
    correct_answer: "keydown",
    incorrect_answers: ["keypress", "keyup", "input"],
  },
  {
    type: "multiple",
    difficulty: "medium",
    category: "JavaScript Events",
    question:
      "Which event is fired when the value of an input element changes and focus leaves it?",
    correct_answer: "change",
    incorrect_answers: ["input", "blur", "focus"],
  },
  {
    type: "multiple",
    difficulty: "hard",
    category: "JavaScript Events",
    question: "Which event is fired continuously while a key is pressed down?",
    correct_answer: "keypress",
    incorrect_answers: ["keydown", "keyup", "input"],
  },
  {
    type: "multiple",
    difficulty: "easy",
    category: "JavaScript Events",
    question:
      "Which event occurs when the mouse pointer moves over an element?",
    correct_answer: "mouseover",
    incorrect_answers: ["mouseout", "mouseenter", "mousemove"],
  },
  {
    type: "multiple",
    difficulty: "hard",
    category: "JavaScript Events",
    question: "What event is triggered when a form is submitted?",
    correct_answer: "submit",
    incorrect_answers: ["click", "change", "input"],
  },
  {
    type: "multiple",
    difficulty: "medium",
    category: "JavaScript Events",
    question: "Which event is fired when an element loses focus?",
    correct_answer: "blur",
    incorrect_answers: ["focus", "change", "input"],
  },
  {
    type: "multiple",
    difficulty: "hard",
    category: "JavaScript Events",
    question: "Which event fires when the DOM content is fully loaded?",
    correct_answer: "DOMContentLoaded",
    incorrect_answers: ["load", "ready", "onload"],
  },
  {
    type: "multiple",
    difficulty: "medium",
    category: "JavaScript Events",
    question: "Which event fires when the mouse wheel is scrolled?",
    correct_answer: "wheel",
    incorrect_answers: ["scroll", "mousewheel", "mousemove"],
  },
  {
    type: "multiple",
    difficulty: "hard",
    category: "JavaScript Events",
    question:
      "Which event is used to detect when a dragged element is being dragged over a valid drop target?",
    correct_answer: "dragover",
    incorrect_answers: ["dragstart", "drop", "dragenter"],
  },
];
